import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../../auth/authSlice";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const fieldSlice = createSlice({
  name: "field",
  initialState,
  reducers: {
    // get field detail
    fetchFieldDetailStart(state) {
      state.isLoading = true;
      state.data = null;
      state.error = false;
      state.success = false;
    },
    fetchFieldDetailSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchFieldDetailFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    // create
    createFieldStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createFieldSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createFieldFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateFieldState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateFieldStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateFieldSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateFieldFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateFieldState(state) {
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // delete
    deleteFieldStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteFieldSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteFieldFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteFieldState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  fetchFieldDetailStart,
  fetchFieldDetailSuccess,
  fetchFieldDetailFailure,
  createFieldStart,
  createFieldSuccess,
  createFieldFailure,
  resetCreateFieldState,
  updateFieldStart,
  updateFieldSuccess,
  updateFieldFailure,
  resetUpdateFieldState,
  deleteFieldStart,
  deleteFieldSuccess,
  deleteFieldFailure,
  resetDeleteFieldState,
} = fieldSlice.actions;

export default fieldSlice.reducer;
